import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// Selectors
// @ts-ignore
import { selectPeopleArray } from 'services/people/selectors';

// Utils
// @ts-ignore
import orderBy from '../../utils/custom-orderBy';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectFilteredData = createDeepEqualSelector(
    selectPeopleArray,
    (peopleArrayState: Record<string, any>[]) =>
        peopleArrayState.filter((value) => value.sprayCertification)
);

const selectOrderedData = createDeepEqualSelector(
    selectFilteredData,
    (filteredDataState) => orderBy(filteredDataState, 'fullName')
);

const selectOptions = createDeepEqualSelector(
    [selectOrderedData],
    (orderedDataState): any =>
        orderedDataState.map(({ id, fullName }: any) => ({
            key: id,
            content: fullName,
            text: fullName,
            value: id
        }))
);

export { selectOptions, selectFilteredData, selectOrderedData };
